<template>

	<v-sheet color="transparent">
		<v-row>
			<v-component v-for="(widget, i) in widgets" :key="i" :is="widget.name" v-bind="widget.bind"></v-component>

		</v-row>
	</v-sheet>
</template>

<script type="text/javascript">
	import Vuex from "vuex"
	export default {
		name: "UserDashboard", 
		data: () => {
			return {
			}
		},
		computed: {
			...Vuex.mapState({
				user: state => state.user,
			}), 
			widgets() {
				var widgets = [];
				if( !this.user.has_organisation ){
					widgets.push({name: "SetUpMyOrganistion", bind: {} })
				}
				// else if( !this.user.has_assessment ){
				// 	widgets.push({name: "NoAssessments", bind: {} })
				// }
				else{
					widgets.push({name: "Welcome", bind: {} })
				}
				this.orderedPins.forEach(pin => {
					widgets.push({name: "PinnedTile", bind: {pin: pin} } )
				})
				return widgets
			},
			orderedPins(){
				var pins = this.user.pins;
				var savedWidgets = this.user.dashboard_settings;

				pins.forEach( w => {
					if( savedWidgets[w.id] ){
						w.position = savedWidgets[w.id].position;
					}
				})
				pins = this.sortByKey(pins, "position");
				return pins;
			}
		}, 
		components: {
			Welcome: () => import("@/components/content/Welcome"), 
			NoAssessments: () => import("@/components/assessment/content/NoAssessments"), 
			SetUpMyOrganistion: () => import("@/components/assessment/organisation/SetUpMyOrganistion"), 
			PinnedTile: () => import("@/components/assessment/PinnedTile")
			// MyAssessment,
			// My
		}, 
		created(){
			this.$store.dispatch("user/getDashboardSettings")
		}
	}
</script>